<template>
  <div class="has-navbar-fixed-bottom has-navbar-fixed-top">
    <TopBar :links="links" :show-drawer.sync="showDrawer" class="top-nav"/>
    <router-view
      class="transition"
      :class="showDrawer ? 'margin-for-drawer' : ''"
    />
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="100">
      <div class="drawer-bg" @click="clickB" v-if="showDrawer"></div>
    </transition>
    <transition enter-active-class="animated drawerIn" leave-active-class="animated drawerOut"  @after-leave="resize" >
      <Drawer  :show-drawer.sync="showDrawer" @clicked="clickB" class="drawer" v-if="showDrawer"/>
    </transition>
    <Bottom :links="links" :show-drawer.sync="showDrawer" class="bottom-nav"/>
  </div>
</template>

<script>
import TopBar from '../components/TopBar.vue'
import Drawer from '../components/Drawer.vue'
import Bottom from '../components/Bottom.vue'
export default {
  name: 'Index',
  components: {
    TopBar,
    Drawer,
    Bottom
  },
  data () {
    return {
      innerHeight: window.innerHeight,
      showDrawer: false,
      pageLinks: [],
      loading: true
    }
  },
  mounted () {
    this.loading = false
  },
  computed: {
    links () {
      const authorised = 'email' in this.$store.state.user.me
      const links = [
        {
          href: authorised ? '/dashboard' : '/',
          title: authorised ? 'Управление' : 'Главная',
          icon: authorised ? 'briefcase' : 'home'
        },
        {
          href: '/map',
          title: 'Карта',
          icon: 'map'
        }
      ]

      return links
    }
  },
  methods: {
    clickB () {
      this.showDrawer = false
    },
    resize () {
      window.dispatchEvent(new Event('resize'))
    }
  }
}
</script>

<style lang="scss" >
  .transition {
    transition: margin-left .2s ease;
  }
  @keyframes slideLeft {
    from {
      transform: translate3d(-100%, 0, 0);
      visibility: visible;
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes slideOutLeft {
    from {
      transform: translate3d(0, 0, 0);
    }

    to {
      visibility: hidden;
      transform: translate3d(-100%, 0, 0);
    }
  }
  .drawerIn {
    animation: ease slideLeft .2s;
  }
  .drawerOut {
    animation: ease slideOutLeft .2s ;
  }
  .has-navbar-fixed-top {
    padding-top: $navbar-height;
  }
  .drawer-bg {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba($color: #000000, $alpha: 0.5);
    z-index: 2;
  }
  .has-navbar-fixed-bottom {
    padding-bottom: $navbar-height;
  }
  .has-navbar-fixed-top .drawer {
    padding-top: $navbar-height;
  }
  .has-navbar-fixed-bottom .drawer {
    padding-bottom: $navbar-height;
  }
  .drawer {
    z-index: 2;
    position: fixed;
    top: 0;
    overflow: auto;
    left: 0;
    width: 300px;
    height: 100%;
    background-color: rgb(230, 230, 230);
  }
  @include desktop {
    .bottom-nav {
      display: none!important;
    }
    .has-navbar-fixed-bottom {
      padding-bottom: 0rem;
    }
    .drawer-bg {
      display: none;
    }
    .margin-for-drawer {
      margin-left: 300px;
    }
    .has-navbar-fixed-bottom .drawer {
      padding-bottom: 0rem;
    }
  }
</style>
